"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const init = (state) => ({ setState }) => {
    if (state) {
        setState(state);
    }
};
exports.default = init;
